import { IContactItemDto, IFilterDto, IPagination, TFieldDefinition } from "../../common/model/Core.model"
import { IClientNestedDto } from "../client/Client.model"
import { IContractNestedDto } from "../contract/Contract.model"
import { IMetadataSection } from "../report-metadata/ReportMetadata.model"

export interface IAssetDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  client: IClientNestedDto
  contract?: IContractNestedDto
  id: string
  sequence: string
  gui: string
  displayName: string
  familyCode: string
  family: string
  areaCode: string
  area: string
  brand: string
  model: string
  serial: string
  countryCode: string
  country: string
  address: string
  latitude: string
  longitude: string
  contacts: IContactItemDto[]
  metadata?: IMetadataSection
  totalReport: number
}

export interface IAssetSearchRequestDto {
  organizationId?: string
  pagination?: IPagination
  fields?: TFieldDefinition
  filters?: IFilterDto[]
}

export interface IAssetUpdateRequestDto {
  assetMetadataId?: string
  contractId?: string
  id?: string
  familyCode?: string
  family?: string
  areaCode?: string
  area?: string
  brand?: string
  model?: string
  serial?: string
  countryCode?: string
  country?: string
  address?: string
  latitude?: string
  longitude?: string
  metadata?: IMetadataSection
}

export interface IAssetCreateRequestDto {
  clientId: string
  assetMetadataId: string
  contractId?: string
  familyCode: string
  family: string
  areaCode: string
  area: string
  brand: string
  model: string
  serial: string
  countryCode?: string
  country?: string
  address?: string
  latitude?: string
  longitude?: string
  metadata?: IMetadataSection
}

// export interface IAssetClient {
//   id: string
//   sequence: string
//   displayName: string
//   sector: string
// }

// export interface IAssetContract {
//   id: string
//   sequence: string
// }

export enum IAssetFilter {
  CLIENT_HASH = 'CLIENT_HASH',
  CLIENT_ID = 'CLIENT_ID',
  CLIENT = 'CLIENT',
  CONTRACT_HASH = 'CONTRACT_HASH',
  CONTRACT_ID = 'CONTRACT_ID',
  HASH = 'HASH',
  ID = 'ID',
  GUI = 'GUI',
  STATUS = 'STATUS',
  FAMILY_CODE = 'FAMILY_CODE',
  FAMILY = 'FAMILY',
  AREA_CODE = 'AREA_CODE',
  AREA = 'AREA',
  BRAND = 'BRAND',
  MODEL = 'MODEL',
  SERIAL = 'SERIAL',
  COUNTRY = 'COUNTRY',
  ADDRESS = 'ADDRESS',
}

export interface IAssetFamily {
  familyCode: string
  family: string
}

export interface IAssetArea {
  familyCode: string
  family: string
  areaCode: string
  area: string
}

export interface IAssetNestedDto {
  createdAt: string
  updatedAt: string
  id: string
  sequence: string
  gui: string
  status: string
  displayName: string
  familyCode: string
  family: string
  areaCode: string
  area: string
  brand: string
  model: string
  serial: string
  address: string
  countryCode: string
  country: string
  latitude: string
  longitude: string
  metadata: IMetadataSection
}